export default __webpack_public_path__ + "static/media/title-deco-left.b8b94d88.webp";